import { useParams, useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { useInsightsData, NewsPost } from "../hooks/useInsightsData";
import RichContentCard from "../components/common/RichContentCard";

export default function NewsContentsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data } = useInsightsData();
  
  const newsData = data.newsPosts.find((p: NewsPost) => p.id === id);

  if (!newsData) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">Page Not Found</h1>
          <button
            onClick={() => navigate("/insights")}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Back to Insights
          </button>
        </div>
      </div>
    );
  }

  return (
    <section className="pt-20 pb-10">
      {/* Close Button */}
      <div className="absolute top-0 right-16 z-50">
        <button onClick={() => navigate("/insights")}>
          <X
            className="absolute top-8 w-12 h-12 text-white rounded-full flex items-center justify-center transition-all duration-300"
            size={24}
          />
        </button>
      </div>
      
      <section className="px-6 md:px-14 space-y-14">
        {newsData.content && newsData.content.map((contentItem, index) => (
          <RichContentCard
            key={index}
            title={contentItem.title}
            titleStyle={contentItem.titleStyle}
            description={contentItem.description}
            image={contentItem.image?.[0] || ''}
            videos={contentItem.videos}
            viewPostUrl={contentItem.viewPostUrl}
          />
        ))}
      </section>
    </section>
  );
}
